import { Button, instantiate, Label, Node, Prefab, _decorator } from 'cc';
import Game from '../../../Game';
import I18n from '../../../I18n/I18n';
import BaseTool from '../BaseTool';
import SupportLanguage, { supportLanguageName } from '../../../I18n/SupportLanguage';

const { ccclass, property } = _decorator;

@ccclass('LanguageSwitcher')
export default class LanguageSwitcher extends BaseTool {
    @property(Prefab)
    private readonly buttonPrefab: Prefab = null;

    @property(Node)
    private readonly i18nOptionContainer: Node = null;

    protected onLoad() {
        const { supportedLanguages } = Game.i18n;
        const languages = Object.values(SupportLanguage);
        languages.forEach((language) => {
            const lang = language;
            const button = this.createButton(lang as SupportLanguage);
            if (!supportedLanguages.some((supportedLanguag) => supportedLanguag === lang)) {
                this.shadowButton(button);
                button._zIndex = 1;
            }
        });
        this.i18nOptionContainer.reorderChildren();
    }

    protected start() {
        Game.i18n.on(I18n.EVENT_TYPE.LanguageChanged, this.updateDisplayName, this);
    }

    protected createButton(lang: SupportLanguage) {
        const newButton = instantiate(this.buttonPrefab);
        newButton.setParent(this.i18nOptionContainer);
        newButton.transform.setContentSize(120, 40);
        newButton.getComponent(Button).on(Button.EventType.CLICK, () => {
            Game.i18n.changeLanguage(lang);
        });

        const label = newButton.getComponentInChildren(Label);
        label.node.transformWidth = 120;
        label.overflow = Label.Overflow.SHRINK;
        label.cacheMode = Label.CacheMode.CHAR;
        label.string = this._getI18nLabelText(lang);
        return newButton;
    }

    protected shadowButton(buttonNode: Node) {
        const button = buttonNode.getComponent(Button);
        button.normalSprite = button.disabledSprite;
        button.hoverSprite = button.disabledSprite;
    }

    protected updateDisplayName(): void {
        this._displayNameLabel.string = this._getI18nLabelText(Game.i18n.currentLanguage);
    }

    private _getI18nLabelText(language: SupportLanguage): string {
        return `${supportLanguageName[language]} (${language})`;
    }
}
